<template>
    <form id="shipping-data-form">
        <div class="headline">
            <span>محصولات ارسالی</span>
        </div>
        <div class="checkout-pack" v-if="cart != null">
            <section class="products-compact">
                <div class="box">
                    <div class="row">
                        <div v-for="cartDetail in cart.CartInfo.CartDetails" class="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div class="product-box-container ">
                                <div class="product-box product-box-compact item">
                                    <span class="discount" v-if="cartDetail.DiscountPercent != 0">{{cartDetail.DiscountPercent}} %</span>
                                    <router-link tag="a" :to="{ name: 'product', params: { productId: cartDetail.ProductId , productName: cartDetail.ProductName.replace(/\s+/g, '-') }}" class="product-box-img">
                                        <img :src="cartDetail.ProductPicPath" @error="imageLoadOnError">
                                    </router-link>
                                    <div class="product-box-title">
                                        {{ cartDetail.ProductName }}
                                    </div>
                                    <div class="price">
                                        <div class="text-center" v-if="cartDetail.DiscountPercent != 0">
                                            <del><span>{{ cartDetail.Price | formatNumber }}<span> تومان </span></span></del>
                                        </div>
                                        <div class="text-center">
                                            <ins><span>{{ cartDetail.FinalPrice | formatNumber }}<span> تومان </span></span></ins>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </form>
</template>

<script>
    export default {
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
        }
    }
</script>

<style scoped>
    .product-box-title {
        margin-bottom: 12px;
    }
    .item .price del,
    .item .price del {
        color: #979898;
        font-size: 13px;
        display: block;
        width: 100%;
    }

    .price del {
        position: relative;
        top: 8px;
        display: block;
        margin-left: 7px;
        font-size: 16px;
        color: #727272;
    }

    .item ins,
    .item ins {
        color: #ef5661;
        font-size: 20px;
        height: 25px;
        text-decoration: none !important;
        display: block;
    }

    l .price ins {
        color: #ef5661;
        font-size: 20px;
        font-weight: 500;
        text-decoration: none;
    }

    .item ins,
    .item ins {
        font-size: 14px;
    }
    .product-box-container {
        padding:10px;
    }
    .product-box {
        border: 1px solid #ddd;
        border-radius: 5px;
      
    }
        .product-box:hover {
            transform: translateY(-2px);
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
        }
    .item{
        position: relative;
    }

        .item .discount {
            content: '';
            width: 45px;
            height: 30px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 1;
            font-size: 14px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .item.discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }
    }
</style>